<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="customerDevelopers"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="客户名称：">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <customer-environment-configuration-edit ref="editCustomerEnvironmentConfiguration" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import CustomerEnvironmentConfigurationEdit from "./CustomerEnvironmentConfigurationEdit";

  export default {
    name: "CustomerEnvironmentConfigurationList",
    components: { CustomerEnvironmentConfigurationEdit, ViewTable},
    data() {
      return {
        limits:{
          addAuth: this.$auth(276),
          editAuth: this.$auth(277),
          delAuth: this.$auth(278),
        },
        filter: {
          customerName: "",
        },
        columnsProperty:[
          {
            title:"客户名称",
            key:"customerName",
            align:"center",
          },
          {
            title:"地址",
            key:"apiBaseUrl",
            align:"center",
          },
          {
            title:"账号",
            key:"username",
            align:"center",
          },
          {
            title:"Token有效期",
            key:"tokenAging",
            align:"center",
          },
          {
            title:"自有物料",
            key:"materialMapping",
            align:"center",
            render: (h, params) => {
              return h("span", params.row.materialMapping ? "是" : "否");
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.editCustomerEnvironmentConfiguration.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        console.log(row);
        let ids = [];
        ids.push(row.pkId);
        this.$http.post("basic", "customerDevelopers/deleteBatch", ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
